export default __webpack_public_path__ + "static/docstation-cfa828b0cbf49ac7b9552d1462009853.svg";